import { SR_API_ACTION_INSURANCE_POLICY_GET_DOWNLOAD_URL } from 'api/utilityActionTypes';

export default async function getDownloadUrl({ state, utilityApiClient }, { policyId }) {
  return utilityApiClient.postWithState({
    action: SR_API_ACTION_INSURANCE_POLICY_GET_DOWNLOAD_URL,
    state,
    queryId: `insurance-policy-download-${policyId}`,
    payload: {
      policyId,
    },
  });
}
